/*
 * Staff/customer discount (aico) — keeps the hidden `properties[_price_item_discount]`
 * input on standard product forms in sync with the selected variant.
 *
 * The form renders the value server-side for the initial variant (see product-form.liquid).
 * On variant change we recompute it from the product's discount multiplier so the correct
 * discounted unit price is posted to the cart. Disabled inputs are not serialized, so when
 * no discount applies we disable it (nothing gets marked). Jerseys use their own path.
 */
(function () {
  'use strict';

  function updateAll(variant) {
    if (!variant || typeof variant.price !== 'number') return;
    var inputs = document.querySelectorAll('input[data-aico-price-discount]');
    for (var i = 0; i < inputs.length; i++) {
      var inp = inputs[i];
      var mult = parseFloat(inp.getAttribute('data-aico-mult'));
      if (!mult || mult >= 1) { inp.value = ''; inp.disabled = true; continue; }
      // Swiss Rappen rounding to nearest 0.05 (matches customer-price.liquid).
      var disc = Math.round((variant.price * mult) / 5) * 5;
      if (disc < variant.price) {
        inp.value = (disc / 100).toFixed(2);
        inp.disabled = false;
      } else {
        inp.value = '';
        inp.disabled = true;
      }
    }
  }

  try {
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS.variantChange) {
      subscribe(PUB_SUB_EVENTS.variantChange, function (evt) {
        updateAll(evt && evt.data && evt.data.variant);
      });
    }
  } catch (e) { /* pub/sub not present on this page — server-rendered value stands */ }
})();
